module.exports = __webpack_public_path__ + "static/assets/6254575e75d05fe637cc61b7197c2123.png";